

export const getSeyirMarkerInstance = (google,map) => {
    return class SeyirMarker extends google.maps.OverlayView {
        position;
        containerDiv;

        constructor(position, data,callback) {
            super();
            this.position = position;

            const seyirAnchor = document.createElement("div");
            seyirAnchor.classList.add("seyir-marker",data.IsVehicleRunning == "1" ? 'running':'not-running');
            seyirAnchor.addEventListener('click',()=> {
                const LL = new google.maps.LatLng(data.Latitude,data.Longitude)
                map.panTo(LL)
                map.setZoom(9)
                callback(data)
            })
            seyirAnchor.innerHTML = data.Vehicle


            this.containerDiv = document.createElement("div");
            this.containerDiv.classList.add("seyir-marker-container","position-absolute");
            this.containerDiv.appendChild(seyirAnchor);
            SeyirMarker.preventMapHitsAndGesturesFrom(this.containerDiv);
        }

        onAdd() {
            this.getPanes()?.floatPane.appendChild(this.containerDiv);
        }

        onRemove() {
            if (this.containerDiv.parentElement) {
                this.containerDiv.parentElement.removeChild(this.containerDiv);
            }
        }

        draw() {
            const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

            const display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? "block": "none";

            if (display === "block") {
                this.containerDiv.style.left = divPosition.x + "px";
                this.containerDiv.style.top = divPosition.y + "px";
            }

            if (this.containerDiv.style.display !== display) {
                this.containerDiv.style.display = display;
            }
        }
    }
}



